<template>
  <div v-if="datas" class="case-detail-region-variant-data-page col-block width-full" :style="{ flex: 1 }">
    <div class="region-variant-data-overview-container col-block width-full">
      <div class="region-variant-data-overview-title-container row-block">
        <div class="region-variant-data-overview-title">{{ $t('COMPONENT.caseDetail.regionVariantData.___overViewTitle') }}</div>
        <div :style="{ flex: 1 }"></div>
      </div>
      <div :style="{ height: '10px' }"></div>
      <div class="region-variant-data-overview-list-container row-block flex-wrap stretch">
        <div class="region-variant-data-overview-data-container col-block stretch" v-for="(option, oindex) in overviewOptions" :key="oindex">
          <div class="region-variant-data-overview-data-header-container center-block">
            <div class="region-variant-data-overview-data-header" :style="{ color: option.color, 'font-weight': option.bold ? 'bold' : '400' }">{{ $t(option.subtitle) }}</div>
          </div>
          <div class="region-variant-data-overview-data-body-container center-block break-line">
            <div class="region-variant-data-overview-data-body">{{ regionData[option.countValue] }}</div>
          </div>
          <a :style="{ flex: 1 }"></a>
        </div>
      </div>
    </div>
    <div :style="{ height: '10px' }"></div>
    <div class="region-variant-data-main-container col-block width-full" :style="{ flex: 1 }">
      <div class="custom-table" :class="{ 'auto-height': false }">
        <div
          v-if="tableWidths"
          class="table-field col-block grab-container"
          :style="{ width: tableWidths.reduce((s, c) => s + c.value, 0) + 'px' }"
          @mousedown.left="e => boardEvent('board1', e, [boardStart])"
          @mousemove="e => boardEvent('board1', e, [boardMove])"
          @mouseout="e => boardEvent('board1', e, [boardMove])"
          @mouseup.left="e => boardEvent('board1', e, [boardEnd])"
        >
          <!-- line -->
          <div class="grab-line x min" :style="lineData.x.min && lineData.x.min.display ? { left: lineData.x.min.value + 'px', display: 'block' } : {}"></div>
          <div class="grab-line x max" :style="lineData.x.max && lineData.x.max.display ? { left: lineData.x.max.value + 'px', display: 'block' } : {}"></div>
          <div class="grab-line x main" :style="lineData.x.main && lineData.x.main.display ? { left: (lineData.x.main.base + lineData.x.main.grab) + 'px', display: 'block' } : {}"></div>
          <div class="grab-line x custom" :style="lineData.x.custom && lineData.x.custom.display ? { left: lineData.x.custom.value + 'px', display: 'block' } : {}"></div>
          <div class="grab-line y min" :style="lineData.y.min && lineData.y.min.display ? { top: lineData.y.min.value + 'px', display: 'block' } : {}"></div>
          <div class="grab-line y max" :style="lineData.y.max && lineData.y.max.display ? { top: lineData.y.max.value + 'px', display: 'block' } : {}"></div>
          <div class="grab-line y main" :style="lineData.y.main && lineData.y.main.display ? { top: (lineData.y.main.base + lineData.y.main.grab) + 'px', display: 'block' } : {}"></div>
          <div class="grab-line y custom" :style="lineData.y.custom && lineData.y.custom.display ? { top: lineData.y.custom.value + 'px', display: 'block' } : {}"></div>
          <!-- /line -->
          <div class="table-container col-block">
            <div class="thead">
              <div class="tr row-block">
                <div
                  v-for="(option, index) in tableOptions"
                  :key="index"
                  class="th row-block"
                  :class="[{ sortable: option.sortMap !== null }, (option.class || (() => []))(null, -1, null)]"
                  :style="{ width: tableWidths[index].value + tableWidths[index].grab + 'px' }"
                  @click="e => !sort.disabled && option.sortMap !== null && tableSortBy(option.sortValue || option.value)"
                >
                  <span class="ellipsis">{{ option.title }}</span>
                  <template v-if="option.titleInfo">
                    <div :style="{ width: '5px' }"></div>
                    <borCor
                      :reverse="true"
                      :background="'white'"
                      :border="'#CCCCCC'"
                      :radius="'0px'"
                      :blockStyle="{ padding: '8px' }"
                    >
                      <div slot="trigger">
                        <img :src="require('../../assets/images/case-af-info-icon.svg')" alt="">
                      </div>
                      <div slot="content">
                        <template v-if="option.titleInfo === '_OVERLAPINFO'">
                          <div class="overlap-info-container col-block flex-start">
                            <div v-if="option.overlapInfo.title" class="overlap-info-title">{{ option.overlapInfo.title }}</div>
                            <div class="overlap-info-content-container col-block width-full">
                              <div class="overlap-info-content-block col-block flex-start" v-for="(info, iindex) in option.overlapInfo.infos" :key="iindex">
                                <div v-if="info.title" class="overlap-info-content-title">{{ info.title + ':' }}</div>
                                <div class="overlap-info-formula-container row-block">
                                  <div class="overlap-info-formula-result">{{ info.formula.result }}</div>
                                  <div class="overlap-info-formula-equal">=</div>
                                  <div class="overlap-info-formula-content col-block">
                                    <div class="overlap-info-formula-numerator">{{ info.formula.numerator }}</div>
                                    <hr>
                                    <div class="overlap-info-formula-denominator">{{ info.formula.denominator }}</div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </template>
                        <template v-else>
                          <div>{{ option.titleInfo }}</div>
                        </template>
                      </div>
                    </borCor>
                  </template>
                  <template v-if="option.value === 'overlap_info'">
                    <div class="overlap-info-info-container row-block">
                      <div
                        class="overlap-info-info-block row-block"
                        v-for="(info, oiindex) in overlapInfoInfos"
                        :key="oiindex"
                      >
                        <div class="overlap-info-info-icon" :style="{ '--icon-color': info.color }"></div>
                        <div class="overlap-info-info-title">: {{ info.title }}</div>
                      </div>
                    </div>
                  </template>
                  <template v-if="option.sortMap !== null">
                    <div :style="{ width: '5px' }"></div>
                    <i :class="['fa', 'fa-sort' + (sort.order[sort.value.indexOf(option.sortValue || option.value)] || '')]" aria-hidden="true"></i>
                  </template>
                  <!-- <div
                    v-if="index + 1 > staticTableWidths[0].length && tableOptions[index + 1 + staticTableWidths[1].length]"
                    class="grab-box grab-x"
                    :class="{ grabbing: boardData['board1'].grabID === index }"
                    :grab-id="index"
                    :grab-type="'x' + { line: '', grab: '*' }[boardType['board1']]"
                    :grab-x-min="tableWidths.slice(0, index).reduce((s, c) => s + c.value, 0) + (option.minWidth || tableMinWidths) + '*'"
                    :grab-x-max="tableWidths.reduce((s, c) => s + c.value, 0) - tableOptions.slice(index + 1, tableOptions.length - staticTableWidths[1].length).reduce((s, c) => s + (c.minWidth || tableMinWidths), 0) - staticTableWidths[1].reduce((s, c) => s + c, 0) + '*'"
                    :grab-x-custom="tableWidths.slice(0, index).reduce((s, c) => s + c.value, 0) + { line: '', grab: '*' }[boardType['board1']]"
                  ></div> -->
                </div>
              </div>
            </div>
          </div>
          <div ref="custom-table-scroll" class="table-group-container col-block width-full">
            <div class="col-block">
              <div class="table-container col-block" v-for="(group, gindex) in tableDatas" :key="gindex">
                <div class="tbody">
                  <div class="tr group row-block" :class="{ selected: false }" :style="group.title ? {} : { height: 0, 'min-height': 0, 'border-bottom': 0, overflow: 'hidden' }">
                    <a class="container-block row-block">
                      <div class="bar"></div>
                      <div
                        v-for="(option, index) in tableOptions"
                        :key="index"
                        class="td row-block"
                        :class="(option.class || (() => []))(group[option.gValue], gindex, group)"
                        :style="{ width: tableWidths[index].value + tableWidths[index].grab - (!tableOptions[index + 1] && tableOverflow ? scrollbarSize : 0) + 'px' }"
                      >
                        <template>
                          <span
                            :style="(option.gstyle || (() => ({})))(group[option.gValue], gindex, group)"
                            :title="((option.gdisplay || (x => x))(group[option.gValue], gindex, group) || '').replace(/\<.+?\>/g, '')"
                            v-html="(option.gdisplay || (x => x))(group[option.gValue], gindex, group) || option.gempty || ''"
                          ></span>
                        </template>
                        <template v-if="option.sortMap !== null && (option.class || (() => []))(group[option.gValue], gindex, group).includes('center') && !(option.class || (() => []))(group[option.gValue], gindex, group).includes('auto-width')">
                          <div :style="{ width: '5px' }"></div>
                          <i :class="['fa', 'fa-sort' + (sort.order[sort.value.indexOf(option.sortValue || option.value)] || '')]" aria-hidden="true" :style="{ opacity: 0 }"></i>
                        </template>
                      </div>
                    </a>
                  </div>
                  <div class="tr col-block" :class="{ selectable: false, selected: false }" v-for="(data, dindex) in group.datas" :key="dindex">
                    <a class="container-block row-block" :style="{ flex: 1 }" @click="e => false && (selectedTableData = data)">
                      <div class="bar"></div>
                      <div
                        v-for="(option, index) in tableOptions"
                        :key="index"
                        class="td row-block"
                        :class="(option.class || (() => []))(data[option.value], dindex, data)"
                        :style="{ width: tableWidths[index].value + tableWidths[index].grab - (!tableOptions[index + 1] && tableOverflow ? scrollbarSize : 0) + 'px' }"
                      >
                        <template v-if="option.value === 'overlap_info'">
                          <databaseOverlapGraph
                            :points="option.pointData(data)"
                            :result="data.d_overlap_pct"
                          ></databaseOverlapGraph>
                        </template>
                        <template v-else-if="option.value === 'phenotype'">
                          <span class="break-line">{{ option.phenotypeData(data).display }}<a class="link" v-if=" option.phenotypeData(data).datas.length > 2" @click="e => detailData = { type: 'phenotype', id: data.d_patientid, data: data }">({{ $t('COMPONENT.caseDetail.regionVariantData.table.DECIPHER.content.___more') }})</a></span>
                        </template>
                        <template v-else>
                          <span
                            :style="(option.style || (() => ({})))(data[option.value], dindex, data)"
                            :title="((option.display || (x => x))(data[option.value], dindex, data) || '').replace(/\<.+?\>/g, '')"
                            v-html="(option.display || (x => x))(data[option.value], dindex, data) || option.empty || '- -'"
                          ></span>
                        </template>
                        <template v-if="option.link">
                          <div :style="{ width: '10px' }"></div>
                          <a :href="option.link(data[option.value], dindex, data)" target="_blank">
                            <img :src="require('../../assets/images/external-link-icon.svg')" alt="">
                          </a>
                        </template>
                        <template v-if="option.sortMap !== null && (option.class || (() => []))(data[option.value], dindex, data).includes('center') && !(option.class || (() => []))(data[option.value], dindex, data).includes('auto-width')">
                          <div :style="{ width: '5px' }"></div>
                          <i :class="['fa', 'fa-sort' + (sort.order[sort.value.indexOf(option.sortValue || option.value)] || '')]" aria-hidden="true" :style="{ opacity: 0 }"></i>
                        </template>
                      </div>
                    </a>
                    <div v-if="(detailData || {}).id === data.d_patientid" class="data-detail-container col-block width-full">
                      <div class="data-detail-hide-container col-block width-full">
                        <div class="data-detail-hide-block row-block" @click="e => detailData = null">
                          <div :style="{ width: '16px' }"></div>
                          <div class="data-detail-hide-title">{{ $t('COMPONENT.caseDetail.regionVariantData.table.DECIPHER.detailData.___hideTitle') }}</div>
                          <img :src="require('../../assets/images/arrow-up-thin.svg')" alt="" :style="{ width: '25px' }">
                          <div :style="{ width: '5px' }"></div>
                        </div>
                      </div>
                      <template v-if="detailData.type === 'phenotype'">
                        <div class="data-detail-phenotype-container col-block width-full">
                          <div class="data-detail-phenotype-title-container row-block">
                            <div class="data-detail-phenotype-title">{{ $t('COMPONENT.caseDetail.regionVariantData.table.DECIPHER.detailData.phenotype.___title', { id: data.d_patientid }) }}</div>
                          </div>
                          <div class="data-detail-phenotype-content-container col-block width-full">
                            <div class="data-detail-phenotype-content" v-html="detailOptions['phenotype'].display(data.d_phenotype)"></div>
                          </div>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="pageData" class="region-variant-data-page-container row-block">
        <div :style="{ width: '10px' }"></div>
        <div class="region-variant-data-page-total">{{ $t('COMPONENT.caseDetail.regionVariantData.page.___total', { total: toPriceString(pageData.total) }) }}</div>
        <div :style="{ flex: 1 }"></div>
        <div class="region-variant-data-page-display">{{ $t('COMPONENT.caseDetail.regionVariantData.page.___display', { display: pageData.display }) }}</div>
        <div :style="{ width: '20px' }"></div>
        <pageButtons
          :default="pageData.selectedPage"
          :display="pageData.display - 0"
          :total="pageData.total"
          :buttonRange="pageData.buttonRange"
          @selectPage="page => { pageData.selectedPage = page; searchDatas() }"
        ></pageButtons>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { getCaseProjectRegionVariantTable, getCaseProjectRegionVariant } from '../../api'
import databaseOverlapGraph from '../case/databaseOverlapGraph.vue'
import pageButtons from '../tool/pageButtons.vue'
import borCor from '../tool/newBorCor.vue'
import responsitive from '../../mixins/responsitive.vue'
import customGrab from '../../mixins/customGrab.vue'
import routeLoading from '../../mixins/routeLoading.vue'
import { convertNumberCount, groupBy, sortData, toPriceString } from '../../constants/global/util'
import { svClinvarOptions, svDECIPHEROptions } from '../../constants/global/data'
import { _LOCAL_BUILD } from '../../constants/global/config'

export default {
  components: {
    databaseOverlapGraph,
    pageButtons,
    borCor
  },
  mixins: [
    responsitive,
    customGrab,
    routeLoading
  ],
  props: {
    type: {
      type: String,
      required: true
    },
    svID: {
      type: String,
      required: true
    },
    caseData: {
      type: Object,
      required: true
    },
    project: {
      type: Object,
      required: true
    },
    regionData: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      datas: null,
      // table
      search: '',
      selectedTableData: null,
      tableWidths: null,
      tableMinWidths: null,
      tableOverflow: false,
      staticTableWidths: [
        [
        ],
        [
        ]
      ],
      sort: {
        disabled: false,
        value: [],
        order: []
      },
      pageData: {
        selectedPage: 1,
        display: 20,
        total: 3000,
        buttonRange: 7
      },
      detailData: null,
      // grab
      boardType: {
        'board1': 'line'
      },
      boardData: {
        'board1': {
          onStart: this.boardResponse('board1', 'start'),
          onMove: this.boardResponse('board1', 'move'),
          onEnd: this.boardResponse('board1', 'end')
        }
      }
    }
  },
  computed: {
    tableDatas () {
      let tableDatas = this.datas || []
      tableDatas = sortData(
        tableDatas,
        this.sort.value.map(x => this.sortMap[x]),
        this.sort.order.map(x => x.replace('-', ''))
      )
      tableDatas = groupBy(tableDatas, () => 'default').map(datas => ({ title: datas[0].group, isGroup: true, datas: datas }))
      return tableDatas
    },
    sortMap () {
      return this.tableOptions.reduce((s, c) => ({ ...s, ...{ [c.value]: c.sortMap || c.value } }), {})
    },
    // static
    overviewOptions () {
      let overviewOptions = {
        'dbVar': svClinvarOptions,
        'DECIPHER': svDECIPHEROptions
      }[this.type]
      overviewOptions = overviewOptions.filter(option => (option.order || {})['overview'])
      overviewOptions = sortData(overviewOptions, option => option.order['overview'], 'asc')
      return overviewOptions
    },
    tableOptions () {
      const classificationOptionMap = {
        'dbVar': svClinvarOptions.reduce((map, option) => ({ ...map, [option.value]: option }), {}),
        'DECIPHER': svDECIPHEROptions.reduce((map, option) => ({ ...map, [option.value]: option }), {})
      }
      const tableOptions = {
        'dbVar': [
          {
            title: this.$t('COMPONENT.caseDetail.regionVariantData.table.dbVar.title.___dbVarID'),
            value: 'id',
            display: (_, __, data) => data.d_dbvarid || data.d_regionid,
            class: () => ['center', 'auto-width'],
            link: (_, __, data) => 'https://www.ncbi.nlm.nih.gov/dbvar/variants/' + (data.d_dbvarid || data.d_regionid) + '/',
            sortMap: null
          },
          {
            title: this.$t('COMPONENT.caseDetail.regionVariantData.table.dbVar.title.___Location'),
            value: 'location',
            display: (_, __, data) => data.d_chr + ':' + data.d_start + '-' + data.d_end,
            class: () => ['center', 'auto-width'],
            sortMap: null
          },
          {
            title: this.$t('COMPONENT.caseDetail.regionVariantData.table.dbVar.title.___Size'),
            value: 'd_svlen',
            display: value => value ? (convertNumberCount(value, ' ', 0.01, false, 2) + 'b').replace(/ b$/, ' bp') : null,
            class: () => ['center', 'auto-width'],
            sortMap: null
          },
          {
            title: this.$t('COMPONENT.caseDetail.regionVariantData.table.dbVar.title.___Classification'),
            value: 'd_classification',
            class: () => ['center', 'auto-width'],
            display: value => {
              value = value ? value.replace(/"/g, '').replace(/ /g, '_') : value
              let option = classificationOptionMap['dbVar'][value]
              return (option && option.title) ? this.$t(option.title) : value
            },
            style: value => {
              value = value ? value.replace(/"/g, '').replace(/ /g, '_') : value
              let option = classificationOptionMap['dbVar'][value]
              return option ? { color: option.color || '#333333', fontWeight: option.bold ? 'bold' : '400' } : null
            },
            sortMap: null
          },
          {
            title: this.$t('COMPONENT.caseDetail.regionVariantData.table.dbVar.title.___Overlapinfo'),
            value: 'overlap_info',
            pointData: data => ({ 's': [data.s_start, data.s_end], 'd': [data.d_start, data.d_end] }),
            class: () => ['center', 'auto-width'],
            titleInfo: '_OVERLAPINFO',
            overlapInfo: {
              title: this.$t('COMPONENT.caseDetail.regionVariantData.table.dbVar.titleInfo.overlapInfo.___title'),
              infos: [
                {
                  title: this.$t('COMPONENT.caseDetail.regionVariantData.table.dbVar.titleInfo.overlapInfo.type.___pathogenic'),
                  formula: {
                    result: this.$t('COMPONENT.caseDetail.regionVariantData.table.dbVar.titleInfo.overlapInfo.formula.___result'),
                    denominator: this.$t('COMPONENT.caseDetail.regionVariantData.table.dbVar.titleInfo.overlapInfo.formula.___denominatorFeature'),
                    numerator: this.$t('COMPONENT.caseDetail.regionVariantData.table.dbVar.titleInfo.overlapInfo.formula.___numerator')
                  }
                },
                {
                  title: this.$t('COMPONENT.caseDetail.regionVariantData.table.dbVar.titleInfo.overlapInfo.type.___other'),
                  formula: {
                    result: this.$t('COMPONENT.caseDetail.regionVariantData.table.dbVar.titleInfo.overlapInfo.formula.___result'),
                    denominator: this.$t('COMPONENT.caseDetail.regionVariantData.table.dbVar.titleInfo.overlapInfo.formula.___denominatorSV'),
                    numerator: this.$t('COMPONENT.caseDetail.regionVariantData.table.dbVar.titleInfo.overlapInfo.formula.___numerator')
                  }
                }
              ]
            },
            sortMap: null
          }
        ],
        'DECIPHER': [
          {
            title: this.$t('COMPONENT.caseDetail.regionVariantData.table.DECIPHER.title.___DECIPHERID'),
            value: 'd_patientid',
            display: value => value ? (value + '') : null,
            class: () => ['center', 'auto-width'],
            link: value => 'https://www.deciphergenomics.org/patient/' + value + '/genotype/' + value + '/browser',
            sortMap: null
          },
          {
            title: this.$t('COMPONENT.caseDetail.regionVariantData.table.DECIPHER.title.___Location'),
            value: 'location',
            display: (_, __, data) => data.d_chr + ':' + data.d_start + '-' + data.d_end,
            class: () => ['center', 'auto-width'],
            sortMap: null
          },
          {
            title: this.$t('COMPONENT.caseDetail.regionVariantData.table.DECIPHER.title.___Size'),
            value: 'd_svlen',
            display: value => value ? (convertNumberCount(value, ' ', 0.01, false, 2) + 'b').replace(/ b$/, ' bp') : null,
            class: () => ['center', 'auto-width'],
            sortMap: null
          },
          {
            title: this.$t('COMPONENT.caseDetail.regionVariantData.table.DECIPHER.title.___Classification'),
            value: 'd_classification',
            class: () => ['center', 'auto-width'],
            display: value => {
              value = value ? value.replace(/"/g, '').replace(/ /g, '_') : value
              let option = classificationOptionMap['dbVar'][value]
              return (option && option.title) ? this.$t(option.title) : value
            },
            style: value => {
              value = value ? value.replace(/"/g, '').replace(/ /g, '_') : value
              let option = classificationOptionMap['dbVar'][value]
              return option ? { color: option.color || '#333333', fontWeight: option.bold ? 'bold' : '400' } : null
            },
            sortMap: null
          },
          {
            title: this.$t('COMPONENT.caseDetail.regionVariantData.table.DECIPHER.title.___Zygosity'),
            value: 'd_genotype',
            class: () => ['center', 'auto-width'],
            display: value => value ? value.slice(0, 3) : null,
            sortMap: null
          },
          {
            title: this.$t('COMPONENT.caseDetail.regionVariantData.table.DECIPHER.title.___Phenotype'),
            value: 'phenotype',
            phenotypeData: data => {
              let phenotypes = data.d_phenotype.replace(/"/g, '').split('; ').filter(x => x)
              return {
                display: !phenotypes.length ? '- -' : (phenotypes.slice(0, 2).join(';')) + (phenotypes.length > 2 ? '; ...' : ''),
                datas: phenotypes
              }
            },
            class: () => ['center', 'auto-width'],
            sortMap: null
          },
          {
            title: this.$t('COMPONENT.caseDetail.regionVariantData.table.DECIPHER.title.___Overlapinfo'),
            value: 'overlap_info',
            pointData: data => ({ 's': [data.s_start, data.s_end], 'd': [data.d_start, data.d_end] }),
            class: () => ['center', 'auto-width'],
            titleInfo: '_OVERLAPINFO',
            overlapInfo: {
              title: this.$t('COMPONENT.caseDetail.regionVariantData.table.DECIPHER.titleInfo.overlapInfo.___title'),
              infos: [
                {
                  title: this.$t('COMPONENT.caseDetail.regionVariantData.table.DECIPHER.titleInfo.overlapInfo.type.___pathogenic'),
                  formula: {
                    result: this.$t('COMPONENT.caseDetail.regionVariantData.table.DECIPHER.titleInfo.overlapInfo.formula.___result'),
                    denominator: this.$t('COMPONENT.caseDetail.regionVariantData.table.DECIPHER.titleInfo.overlapInfo.formula.___denominatorFeature'),
                    numerator: this.$t('COMPONENT.caseDetail.regionVariantData.table.DECIPHER.titleInfo.overlapInfo.formula.___numerator')
                  }
                },
                {
                  title: this.$t('COMPONENT.caseDetail.regionVariantData.table.DECIPHER.titleInfo.overlapInfo.type.___other'),
                  formula: {
                    result: this.$t('COMPONENT.caseDetail.regionVariantData.table.DECIPHER.titleInfo.overlapInfo.formula.___result'),
                    denominator: this.$t('COMPONENT.caseDetail.regionVariantData.table.DECIPHER.titleInfo.overlapInfo.formula.___denominatorSV'),
                    numerator: this.$t('COMPONENT.caseDetail.regionVariantData.table.DECIPHER.titleInfo.overlapInfo.formula.___numerator')
                  }
                }
              ]
            },
            sortMap: null
          }
        ]
      }
      return tableOptions[this.type]
    },
    detailOptions () {
      return {
        'phenotype': {
          display: value => value.replace(/"/g, '')
        }
      }
    },
    overlapInfoInfos () {
      return [
        {
          title: this.$t('COMPONENT.caseDetail.regionVariantData.table.overlapInfo.title.___sample'),
          color: '#003679'
        },
        {
          title: this.$t('COMPONENT.caseDetail.regionVariantData.table.overlapInfo.title.___db'),
          color: '#999999'
        }
      ]
    },
    // global
    toPriceString () { return toPriceString }
  },
  watch: {
    // table
    'selectedTableData' (nv, ov) {
      if (nv !== ov && JSON.stringify(nv) !== JSON.stringify(ov)) {
        this.selectedTableData = nv ? JSON.parse(JSON.stringify(nv)) : null
      }
    },
    'tableDatas' () {
      this.getTableOverflow()
    },
    'windowWidth' (nv) {
      this.getTableWidths(nv)
      this.getTableOverflow()
    }
  },
  methods: {
    ...mapActions([
      'setLoadingAction'
    ]),
    async fetchData () {
      await this.fetchVariantDatas(true)
    },
    async fetchVariantDatas (reset = false) {
      try {
        let config = this.$ls.get('userInfo')
        let id = this.caseData.id
        let projectID = this.project.id
        let svID = this.svID
        let response = null
        // table
        if (!this.tableName) {
          let tableData = {}
          response = await getCaseProjectRegionVariantTable(id, projectID, tableData, config)
          let tableName = !_LOCAL_BUILD ? response.data.data.table_name : response.data.data.session
          this.tableName = tableName
        }
        // query
        reset && (this.pageData.selectedPage = 1)
        let data = {
          table_name: this.tableName,
          session: this.tableName,
          db_name: this.type,
          limit: 20,
          page: this.pageData.selectedPage
        }
        response = await getCaseProjectRegionVariant(id, projectID, svID, data, config)
        let datas = response.data.data.data
        reset && (this.pageData.total = (response.data.data.total_count - 0))
        this.datas = datas
      } catch (error) {
        this.pageData.total = 0
        this.datas = []
        throw error
      }
    },
    async searchDatas () {
      this.setLoadingAction(true)
      await this.fetchVariantDatas()
      this.$refs['custom-table-scroll'].scrollTop = 0
      this.setLoadingAction(false)
    },
    // table
    getTableOverflow () {
      setTimeout(() => {
        let scrollContainer = this.$refs['custom-table-scroll']
        if (scrollContainer) {
          this.tableOverflow = scrollContainer.scrollHeight > scrollContainer.offsetHeight
        }
      })
    },
    getTableWidths (windowWidth) {
      let tableWidth = Math.min(windowWidth * 0.95, 1208) - (22 * 2)
      tableWidth = tableWidth - this.staticTableWidths[0].reduce((s, c) => s + c, 0) - this.staticTableWidths[1].reduce((s, c) => s + c, 0)
      let defaultWidth = {
        'dbVar': [
          199,
          259,
          146,
          244,
          320
        ],
        'DECIPHER': [
          106,
          204,
          96,
          174,
          90,
          178,
          320
        ]
      }[this.type]
      let tableWidths = this.tableWidths || [
        ...this.staticTableWidths[0],
        ...defaultWidth,
        ...this.staticTableWidths[1]
      ].map(width => ({
        value: width
      }))
      let tableMinWidths = this.tableMinWidths || 0.1
      tableWidths = tableWidths.slice(this.staticTableWidths[0].length, tableWidths.length - this.staticTableWidths[1].length)
      let ratio = tableWidth / tableWidths.reduce((s, c) => s + c.value, 0)
      tableWidths = Array.prototype.concat.apply([], [
        this.staticTableWidths[0].map(width => ({
          value: width,
          grab: 0
        })),
        tableWidths.map(width => ({
          value: width.value * ratio,
          grab: 0
        })),
        this.staticTableWidths[1].map(width => ({
          value: width,
          grab: 0
        }))
      ])
      this.tableMinWidths = tableMinWidths * ratio
      this.tableWidths = tableWidths
    },
    tableSortBy (value) {
      let position = this.sort.value.indexOf(value)
      if (position === 0) {
        let order =
          this.sort.order[position] === '-asc' ? '-desc' : '-asc'
        this.sort.order.splice(position, 1)
        this.sort.order.unshift(order)
      } else {
        let order =
          position !== -1
            ? this.sort.order[position] === '-asc' ? '-desc' : '-asc'
            : undefined
        position = position !== -1 ? position : 0
        this.sort.value.splice(position, 1)
        this.sort.order.splice(position, 1)
        this.sort.value.unshift(value)
        this.sort.order.unshift(order || '-asc')
      }
    },
    // grab
    boardResponse (id, type) {
      return {
        'board1': {
          'start': boardData => {
            this.sort.disabled = true
          },
          'move': boardData => {
            if (this.boardType['board1'] === 'grab') {
              let grabID = this.boardData[id].grabID
              let tableWidths = [...this.tableWidths]
              let result = boardData.grabX - boardData.baseX
              let ratioBase = tableWidths.slice(grabID + 1, tableWidths.length - this.staticTableWidths[1].length).reduce((s, c, i) => s + c.value - (this.tableOptions[i].minWidth || this.tableMinWidths), 0)
              tableWidths.forEach((_, i) => {
                if (i === grabID) {
                  tableWidths[i].grab = result
                } if (i > grabID && i + this.staticTableWidths[1].length < tableWidths.length) {
                  tableWidths[i].grab = -(result * ((tableWidths[i].value - (this.tableOptions[i].minWidth || this.tableMinWidths)) / ratioBase))
                }
              })
              this.tableWidths = tableWidths
            }
          },
          'end': boardData => {
            let grabID = this.boardData[id].grabID
            let tableWidths = [...this.tableWidths]
            let result = boardData.grabX - boardData.baseX
            let ratioBase = tableWidths.slice(grabID + 1, tableWidths.length - this.staticTableWidths[1].length).reduce((s, c, i) => s + c.value - (this.tableOptions[i].minWidth || this.tableMinWidths), 0)
            tableWidths.forEach((_, i) => {
              tableWidths[i].grab = 0
              if (i === grabID) {
                tableWidths[i].value += result
              } if (i > grabID && i + this.staticTableWidths[1].length < tableWidths.length) {
                tableWidths[i].value -= result * ((tableWidths[i].value - (this.tableOptions[i].minWidth || this.tableMinWidths)) / ratioBase)
              }
            })
            this.tableWidths = tableWidths
            setTimeout(() => { this.sort.disabled = false })
          }
        }
      }[id][type]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/caseDetail/regionVariantData.vue